import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { useDraftStore, useOnboardingSubmission, type OnboardingPayload } from '../../features/onboarding'
import { PRODUCT_CONFIG, type ProductConfig } from './registry'
import { useAnalyticsScreen } from '../../lib/analytics'

export default function OnboardingRoute({ config = PRODUCT_CONFIG.humanteq }: { config?: ProductConfig }) {
  useAnalyticsScreen('/onboarding', config.id !== 'break_up', config.id)
  const navigate = useNavigate()
  const userId = useAuthStore((s) => s.isAuthenticated() ? s.userId : null)
  const [draft] = useState(() => useDraftStore.getState().ensure(config.id, config.onboarding.id, config.onboarding.version, userId, config.onboarding.variant))
  const payload = useDraftStore(s => s.draft?.id === draft.id ? s.draft.answers : draft.answers)
  const { submit, submitting, error } = useOnboardingSubmission()
  const change = useCallback((answers: OnboardingPayload) => { useDraftStore.getState().update(draft.id, answers) }, [draft.id])
  const complete = useCallback(async (answers: OnboardingPayload) => {
    change(answers)
    useDraftStore.getState().markReady(draft.id)
    if (!userId) { navigate('/register'); return }
    const current = useDraftStore.getState().draft
    if (current && await submit(current)) navigate(config.onboarding.completionPath ?? '/', { replace: true })
  }, [change, draft.id, navigate, submit, userId, config.onboarding.completionPath])
  const Scenario = config.onboarding.Component
  return <Scenario payload={payload} submitting={submitting} error={error} onChange={change} onComplete={complete} />
}
